import React from 'react';

const Credit = () => {
  return (
    <div className="credit intro__container mt-0 md:mt-[2.5vh] rounded-tl-0 rounded-tr-0 md:rounded-tl-[20px] md:rounded-tr-[20px] h-[80%] overflow-scroll">
      <div className="text-ink mb-[50px]">
        <h4>分析方法：</h4>
        <p>歪脑整理搜集了爱奇艺制作的三季网络音乐综艺节目《乐队的夏天》和湖南卫视热播的三季《乘风破浪的姐姐》以及《乘风2023》共七季节目中，公演的全部475首歌曲。通过对比综艺中的歌词字幕和原曲发行时的歌词，统计出126处歌词在播出时原词被改动的实例。原曲歌词主要来源自百度百科和香港魔镜歌词网。公演歌曲中新添的歌词和说唱部分不包括在统计分析中；大段省略过的情况也不与统计。</p>
        <p>《乐队的夏天》三季节目共公演313首歌曲，其中33首歌曲歌词有85处明显更改。《乘风》系列节目共公演了162首歌曲，11首歌曲的歌词有41处改动。</p>
        <p>歪脑还综合参考了《电视剧内容制作通则》和网易盾的网络敏感词分类，对被改动的歌词进行了归纳分类。</p>
        <h4>分析样本</h4>
        <p>三季“乘风破浪的姐姐”和“乘风2023”公演的162首歌曲。其中：</p>
        <ul>
          <li>第一季 2020年6月12日—9月4日播出，共12期节目，公演43首歌曲</li>
          <li>第二季 2021年1月22日—4月16日播出，共13期节目，公演39首歌曲</li>
          <li>第三季 2022年5月20日—8月5日播出，共12期节目，公演35首歌曲</li>
          <li>第四季改名“乘风2023”，2023年5月5日—7月21日播出，共12期节目，公演45首歌曲</li>
        </ul>
        
        <p>三季“乐队的夏天”公演的313首歌曲。其中：</p>
        <ul>
          <li>第一季 2019年5月25日至8月10日播出，共12期节目，演唱歌曲101首</li>
          <li>第二季 2020年7月25日至10月10日播出，共15期节目，演唱歌曲120首</li>
          <li>第三季2023年8月25日至10月20日播出，共11期节目，演唱歌曲92首</li>
        </ul>
        
        <h4>敏感词分类</h4>
        <p>歪脑综合参考了《电视剧内容制作通则》和网易盾的网络敏感词分类，对被改动的歌词进行了归纳分类，包括涉及政治、涉及暴力、涉及色情淫秽、烟酒毒、脏话谩骂、宣扬宗教信仰、以及表现消极态度等七大类。</p>
        <p>被改掉的带有消极负面情绪的词句最多，如“不见天亮”、“卑微”、“软烂中生长”等，取而代之的通常带有明显的“正能量”，或偏中性的词语。如用“愿见天亮”替换“不见天亮”，“平凡”取代“卑微”，和“散漫中生长”。</p>
        <p>另外一些被修改的歌词，或涉及个性化的描述、商业品牌，或无明显类型，统一归入“其他”类。</p>
        <h4>参考资料</h4>
        <ul>
          <li>百度百科</li>
          <li>魔镜歌词</li>
          <li><a href="https://www.sohu.com/a/61883713_154166" target="_blank" rel="noreferrer">电视剧内容制作通则</a></li>
          <li><a href="https://dun.163.com/product/text-detection" target="_blank" rel="noreferrer">网易网盾</a></li>
          <li>爱奇艺</li>
          <li>湖南卫视（中国官方媒体）</li>
        </ul>
        
        <h4>Credit</h4>
        <ul>
          <li>策划: Paul Wang</li>
          <li>文案: Rosa Ng</li>
          <li>顾问: Vivian Lee</li>
          <li>设计: Carrie Jia</li>
          <li>制作: Vic Kim</li>
        </ul>
        
      </div>
    </div>
  );
};

export default Credit;